import { Component, computed, signal } from '@angular/core';

interface Testimonial{
  id: number;
  comment: string;
  customer: string;
  img: string;
  alt: string;
}

@Component({
  selector: 'app-what-our-customers-say',
  imports: [],
  templateUrl: './what-our-customers-say.html',
  styleUrl: './what-our-customers-say.css',
})
export class WhatOurCustomersSay {
  testimonials: Testimonial[] = [
    {
      id: 1, 
      comment: 'Lost track of how many times I ordered be well from their flagship store but 2 boxes arrived complete... I’m always satisfied..', 
      customer: 'M***', 
      img: 'assets/lazada.png',
      alt: 'Lazada'
    },
    {
      id: 2, 
      comment: 'Been drinking this ever since it arrived. thank you for this legit product bought at a lower price last Laz B-Day Sale will surely order again.', 
      customer: 'J***', 
      img: 'assets/lazada.png',
      alt: 'Lazada'
    },
    {
      id: 3, 
      comment: 'Excellent quality... lowest price.... fast delivery...... this is my second order....... thank you, seller.', 
      customer: 'L***', 
      img: 'assets/lazada.png',
      alt: 'Lazada'
    },
    {
      id: 4, 
      comment: 'Package was well packed and was shipped and received immediately. With seal and no damage or dents in the box. Expiration is 2023 pa. We love this brand because this is non-acidic', 
      customer: 't*****', 
      img: 'assets/shopee.png',
      alt: 'Shopee'
    },
    {
      id: 5, 
      comment: 'Always an excellent product, especially during the pandemic. Very affordable and does not cause hyperacidity. Highly recommended seller.', 
      customer: 'Erickjurell', 
      img: 'assets/shopee.png',
      alt: 'Shopee'
    },
    {
      id: 6, 
      comment: 'Packed well and shipped immediately. Legit since I bought it from the official store. This is my first time trying this so hopefully hiyang', 
      customer: 'L****', 
      img: 'assets/shopee.png',
      alt: 'Shopee'
    }
  ];

  currentIndex = signal(0);
  itemsToShow = 3;

  isPrevDisabled = computed(() => this.currentIndex() === 0);
  isNextDisabled = computed(() => this.currentIndex() >= this.testimonials.length - this.itemsToShow);

  trackTransform = computed(() => `translateX(-${this.currentIndex() * 33.3333}%)`);

  next() {
    if (!this.isNextDisabled()) {
      this.currentIndex.update(index => index + 1);
    }
  }

  prev() {
    if (!this.isPrevDisabled()) {
      this.currentIndex.update(index => index - 1);
    }
  }
}
